/**
 * This is your main. This is where you re-export everything you want to be publicly available.
 *
 * The build enforces that the file has the same name as the global variable that is exported.
 */

export {
  ApiRequests,
  ApiRequestsTypes,
} from './dataCatalogShared/apiRequests/ApiRequests';

export {
  ApiRequestsContext,
} from './dataCatalogShared/apiRequests/ApiRequestsContext';

export {
  BreadcrumbStateInfo,
  UIActions,
} from './dataCatalogShared/uiActions/UIActions';

export { FeatureFlags } from './dataCatalogShared/featureFlags/FeatureFlags';

export {
  apolloClientGenerator,
  createDataCatalogInMemoryCache,
  DataCatalogApolloClient,
  queryOptions,
} from './dataCatalogShared/apolloClientGenerator';

export { GraphQLError } from './dataCatalogShared/graphQL/GraphQLError';

export {
  ConnectionListResult,
  getAllFromSliceable,
  GraphQLSliceable,
  GraphQLSliceableParams,
  makeRowFetcher,
  PaginationQueryVariables,
  PartialQueryVariables,
  Sliceable,
  SliceResult,
} from './dataCatalogShared/graphQL/GraphQLSliceable';

export {
  ActiveUser,
  DeletedUser,
  getUserNameForDisplay,
  isUserInfoVisible,
  TableauUser,
  UserLinkDisplayComponent,
  UserLinkDisplayComponentProps,
  UserTextDisplayComponent,
  UserTextDisplayComponentProps,
  UserLinkProps,
} from './dataCatalogShared/UserDisplayComponent';

export {
  ProjectLocationLinkDisplayComponent,
  ProjectLocationLinkDisplayComponentProps,
  ProjectLocationLinkProps
} from './dataCatalogShared/dataGrid/ProjectLocationDisplayComponent';

export { OrderBy } from './dataCatalogShared/dataGrid/sort/OrderBy';

export {
  createServerOrPathString,
} from './dataCatalogShared/dataGrid/cellFormatters/ServerOrPathCell';

export {
  IOrderClause,
  ListViewGridColumnGeneratorParams,
} from './dataCatalogShared/utils/VizPortalTypes';

export {
  buildDefaultOrder,
  DefaultDirections,
  SortProviderProps,
} from './dataCatalogShared/dataGrid/sort/SortProviderProps';

//#region DATA QUALITY INDICATORS
export {
  GraphDataQualityWarning,
  RenderWarningsFromGraph,
  RenderWarningsFromGraphProps,
  RenderWarningsFromGraphAndVizportal,
  RenderWarningsFromGraphAndVizportalProps,
} from './dataCatalogShared/dataQualityWarnings/DataQualityWarningFragments';

export {
  CertificationStatusProps,
  WarningStatusProps,
  AssetMarkedByIndicator,
} from './dataCatalogShared/dataQualityIndicators/DataQualityIndicatorFragments';

export {
  WarningStatusIcon,
  WarningStatusChip,
  CertificationStatusChipOrIcon,
  EmbeddableWarningStatusChip,
  EmbeddableWarningStatusIcon,
  EmbeddableCertificationStatusChipOrIcon,
} from './dataCatalogShared/dataQualityIndicators/DataQualityIndicatorStatusChip';

export {
  DataQualityWarningInteractiveButton
} from './dataCatalogShared/dataQualityIndicators/DataQualityIndicatorButtons';

export {
  DataQualityType,
  localizeDataQualityTypeName,
} from './dataCatalogShared/dataQualityWarnings/DataQualityType';

export {
  DataQualityAssetType
} from './dataCatalogShared/dataQualityWarnings/DataQualityWarningFragments';

export {
  DataQualityDetailProps,
} from './dataCatalogShared/dataQualityWarnings/DataQualityDetail';

export {
  DataQualityDetailContent,
} from './dataCatalogShared/dataQualityWarnings/DataQualityDetailPanel';

export {
  DataQualityDetailPanelDialogStyle,
} from './dataCatalogShared/style/DataQualityStyles';
//#endregion

export {
  DataQualityStatusChip,
  EmbeddableDataQualityStatusChip,
} from './dataCatalogShared/dataQualityWarnings/DataQualityStatusChip';

export {
  FeatureFlagsProvider,
  VizPortalSearchResultsDataCatalogProvider,
  VizPortalDQWDataCatalogProvider,
  VizPortalDQWDataCatalogProviderProps,
} from './dataCatalogShared/DataCatalogProvider';

export {
  ErrorCatcher,
} from './dataCatalogShared/error/components/ErrorCatcher';

export {
  ComposeEmailPaneButton,
} from './dataCatalogShared/contentActions/emailDownstreamUsers/ComposeEmailPaneButton';

export {
  HorizontalFlexContainer,
  VerticalFlexContainer,
} from './dataCatalogShared/style/LayoutComponents';

export {
  classes,
  cssClass,
  Style,
} from './dataCatalogShared/style/StyleFunctions';

export {
  sharedDialogTelemetry,
} from './dataCatalogShared/telemetry/SharedDialogTelemetry';

export {
  TelemetryContext,
  TelemetryEnvironment,
} from './dataCatalogShared/telemetry/TelemetryContext';

export {
  telemetrySender,
} from './dataCatalogShared/telemetry/TelemetrySender';

export {
  UIActionsContext,
} from './dataCatalogShared/uiActions/UIActionsContext';

export { divWithStyle } from './dataCatalogShared/style/LayoutComponents';

export {
  messageForConnectionType,
} from './dataCatalogShared/displayUtils/MessageUtils';

export {
  defaultFeatureFlagsWithOverrides,
  FeatureFlagsContext,
} from './dataCatalogShared/featureFlags/FeatureFlagsContext';

export {
  aboutHeader,
  aboutHeaderConnectionTypeDetailIcon,
  aboutHeaderConnectionTypeDetailItem,
  aboutHeaderConnectionTypeDetailText,
  aboutHeaderDescriptionAndTags,
  aboutHeaderDescriptionAndTagsContent,
  aboutHeaderDetailItem,
  aboutHeaderDetailLabel,
  aboutHeaderDetailsTextElide,
  aboutHeaderDetailsWrapper,
  aboutHeaderInfoIcon,
  aboutHeaderPlaceholderText,
} from './dataCatalogShared/style/AboutHeaderDetailsStyles';

export { linkClass } from './dataCatalogShared/style/VizPortalStyles';

export {
  assertUnreachable,
  filterOutNullAndUndefined,
  membersAreDefined,
} from './dataCatalogShared/utils/TypescriptHelpers';

export { GraphQLErrorCode } from './dataCatalogShared/graphQL/GraphQLError';

export {
  reportGraphQLErrors,
} from './dataCatalogShared/graphQL/GraphQLErrorFunctions';

export {
  getFirstGraphQLErrorCode,
  getMessageForErrorCode,
  isFatalError,
  reportGraphQLError,
  reportNoData,
} from './dataCatalogShared/graphQL/GraphQLErrorFunctions';

export {
  createDefaultSiteUrls,
  SiteUrlsContext,
} from './dataCatalogShared/urls/SiteUrlsContext';

export { GridSortProps } from './dataCatalogShared/dataGrid/sort/GridSortProps';

export {
  PaginatedQueryWrapper,
} from './dataCatalogShared/graphQL/PaginatedQueryWrapper';

export {
  MaxCountsResultData,
} from './dataCatalogShared/maxCounts/types/MaxCountsResultData';

export {
  minWidthClass,
  vizPortalFontClass,
} from './dataCatalogShared/style/VizPortalStyles';

export {
  flexRowStyle,
  flexColumnStyle,
} from './dataCatalogShared/style/LayoutStyles';

export {
  headerPaddingStyle,
  nonPlaceTitleStyle,
  spaceHeaderContentStyle,
} from './dataCatalogShared/style/VizPortalStyles';

export {
  UrlSearch,
  UrlSearchProvider,
} from './dataCatalogShared/urls/UrlSearchProvider';

export {
  getFirstParamValueAsSet,
  getSingleParamValue,
  paramValuesMapToSearch,
  removeParamValue,
  searchToParamValuesMap,
  setParamValues,
} from './dataCatalogShared/urls/UrlSearchFunctions';

export { vizPortalFontStyle } from './dataCatalogShared/style/VizPortalStyles';

export {
  LineageBrowserDataCatalogProvider,
  VizClientDataCatalogProvider,
  VizPortalDataCatalogProviderProps,
} from './dataCatalogShared/DataCatalogProvider';

export {
  getMaxDownstreamDatasources,
  getMaxDownstreamWorkbooks,
} from './dataCatalogShared/maxCounts/functions/MaxCountsFunctions';

export {
  RemoteTypeMappings,
} from './dataCatalogShared/utils/RemoteTypeMapping';

export {
  MultiSelectionProvider,
} from './dataCatalogShared/dataGrid/SelectionProvider';

export {
  DropdownLabel,
  PaneTitle,
} from './dataCatalogShared/style/SubplaceStyles';

export {
  SelectionProviderChildProps,
} from './dataCatalogShared/dataGrid/SelectionProvider';

export {
  getFilteredCountRatio,
  MessageWithAndWithoutCount,
  messageWithOrWithoutCount,
} from './dataCatalogShared/displayUtils/FormatUtils';

export {
  DatabaseMastheadIcon,
  DatabaseMediumIcon,
  DatabaseTypename,
  getDatabaseIconTooltip,
} from './dataCatalogShared/icons/DatabaseIcon';

export {
  PlaceHeaderMetadataItem,
  PlacePageActionsMenu,
  PlacePageHeader,
  placePageIconClass,
  PlacePageMastheadContainer,
  PlacePageMastheadRowContainer,
  PlacePageTitle,
  PlacePageTitleContainer,
} from './dataCatalogShared/style/PlaceStyles';

export { CenteredMessage } from './dataCatalogShared/CenteredMessage';
export { CenteredFadeInSpinner } from './dataCatalogShared/CenteredSpinner';

export {
  defaultDataGridProps,
  ExplorerStyledDisplayGrid,
  SelectionMode,
} from './dataCatalogShared/dataGrid/ExplorerStyledDisplayGrid';

export {
  createSelectionColumn,
} from './dataCatalogShared/dataGrid/SelectionColumn';

export {
  TypedBodyCellProps,
  TypedColumn,
  TypedRow,
  TypedRowStoreWithErrorsProps,
  TypedRowHandlerWithErrors,
  TypedRowStoreWithErrors,
  UnsortableColumnKey,
  UsualDisplayGridProps,
} from './dataCatalogShared/dataGrid/TypedDataGridInterfaces';

export {
  cellDisabledStyle,
  cellPaddingStyle,
} from './dataCatalogShared/dataGrid/cellFormatters/CellStyles';

export {
  TextCellFormatter,
} from './dataCatalogShared/dataGrid/cellFormatters/TextCellFormatter';

export { elideTextStyle } from './dataCatalogShared/style/LayoutStyles';

export {
  createCountBarCellFormatter,
} from './dataCatalogShared/dataGrid/cellFormatters/CountBarCellFormatter';

export {
  PlaceholderTextCell,
} from './dataCatalogShared/dataGrid/cellFormatters/PlaceholderTextCell';

export {
  createTextCellFormatter,
} from './dataCatalogShared/dataGrid/cellFormatters/TextCellFormatter';

export { ColorPaletteName } from './dataCatalogShared/style/CountBarStyles';

export {
  SortableHeaderFormatter,
} from './dataCatalogShared/dataGrid/headerFormatters/SortableHeaderFormatter';

export {
  getPaddingTopStyleForTextWithIcon,
  MetadataTable,
  MultiLineLinkWithIcon,
  ViewerPaneObfuscatedPlaceholder,
} from './dataCatalogShared/ViewerPaneLayoutComponents';

export {
  createIconCellFormatter,
  getDSHoverTitleString,
} from './dataCatalogShared/dataGrid/cellFormatters/IconCellFormatter';

export {
  ColumnFactory,
  mapDC3ColumnFactoriesToVizPortalColumnFactories,
} from './dataCatalogShared/dataGrid/ColumnFactory';

export {
  createSortableHeaderFormatter,
} from './dataCatalogShared/dataGrid/headerFormatters/SortableHeaderFormatter';

export { ErrorListContext } from './dataCatalogShared/error/ErrorListContext';
export {
  ErrorDisplayInfo,
} from './dataCatalogShared/error/types/ErrorDisplayInfo';
export {
  ErrorInfo,
  ErrorList,
} from './dataCatalogShared/error/types/ErrorList';

export {
  getToastMessageForErrorCode,
} from './dataCatalogShared/graphQL/GraphQLErrorFunctions';

export {
  getErrorDisplayInfo,
  getGraphQLErrorCode,
} from './dataCatalogShared/graphQL/GraphQLErrorFunctions';

export { DropdownWrapper } from './dataCatalogShared/style/SubplaceStyles';

export {
  DropdownSelectedItem,
  dropdownStyle,
} from './dataCatalogShared/style/SubplaceStyles';

export {
  lineageBarHeight,
  lineageBarMaxWidth,
} from './dataCatalogShared/style/CountBarStyles';

export { keyframes } from './dataCatalogShared/style/StyleFunctions';

export {
  CertificationWidget,
  CertificationWidgetProps,
  getCertifierPropsFromCertifier,
} from './dataCatalogShared/CertificationWidget';

export {
  certificationIconStyle,
} from './dataCatalogShared/style/VizPortalStyles';

export {
  placeHeaderMetadataLabelClass,
  placeHeaderMetadataValueClass,
} from './dataCatalogShared/style/PlaceStyles';

export {
  placeHeaderMetadataLinkClass,
} from './dataCatalogShared/style/VizPortalStyles';

export {
  placePageIconContainerClass,
} from './dataCatalogShared/style/PlaceStyles';

export {
  DataQualityCellFormatterOpts,
  DataQualityCellFormatterRowDataFunctions,
  createDataQualityCellFormatter,
} from './dataCatalogShared/dataGrid/cellFormatters/QualityCellFormatter';

export {
  DataQualityIconHeaderFormatterFactory,
} from './dataCatalogShared/dataGrid/headerFormatters/DataQualityIconHeaderFormatFactory';

export {
  DataQualityIconHeaderCertificationFormatterFactory,
} from './dataCatalogShared/dataGrid/headerFormatters/DataQualityIconHeaderFormatFactory';

export {
  GenerateCertificationTooltipComponent,
} from './dataCatalogShared/dataGrid/cellFormatters/DatasourceTypeCell';

export {
  DataGridWithSynchronousRowStore,
  DataGridWithSynchronousRowStoreProps,
  OverlayWithSpinner,
} from './dataCatalogShared/dataGrid/DataGridWithSynchronousRowStore';

export {
  ListViewRowOuterHeight,
} from './dataCatalogShared/style/VizPortalStyles';

export {
  UserAndSiteSettings,
  UserAndSiteSettingsContext,
} from './dataCatalogShared/utils/UserAndSiteSettingsContext';

export { TableMediumIcon } from './dataCatalogShared/icons/TableIcon';

export {
  UrlSortProvider,
} from './dataCatalogShared/dataGrid/sort/UrlSortProvider';

export { TableMastheadIcon } from './dataCatalogShared/icons/TableIcon';

export { Logger } from './dataCatalogShared/utils/Logger';

export { objectValues } from './dataCatalogShared/utils/ObjectHelpers';

export {
  DarkGreenText,
  userSelectStyle,
} from './dataCatalogShared/style/StyleConstants';

export {
  AccessibleHyperLinkBlue,
  AccessibleHyperLinkBlueFocus,
  AccessibleHyperLinkBlueHover,
} from './dataCatalogShared/style/VizPortalStyles';

export {
  interpolateString,
} from './dataCatalogShared/utils/StringInterpolation';

export {
  MultiSelectionProviderChildProps,
} from './dataCatalogShared/dataGrid/SelectionProvider';

export {
  SingleSelectionProvider,
} from './dataCatalogShared/dataGrid/SelectionProvider';

export {
  AssetParentProps,
  ColumnDescriptionDialog,
  ColumnDescriptionDialogProps,
} from './dataCatalogShared/description/ColumnDescriptionDialog';

export { ItemWithId } from './dataCatalogShared/graphQL/ItemWithId';

export {
  DataQualityWarningIndicator,
} from './dataCatalogShared/dataQualityIndicators/DataQualityIndicatorFragments';

export {
  PaginatedRowStore,
  QueryRows,
} from './dataCatalogShared/dataGrid/PaginatedRowStore';

export {
  SortProviderNoUrl,
} from './dataCatalogShared/dataGrid/sort/SortProviderNoUrl';

export { UserPlaceholderStyle } from './dataCatalogShared/UserDisplayComponent';

export { SimpleDeferred } from './dataCatalogShared/utils/SimpleDeferred';

export {
  ErrorReporter,
} from './dataCatalogShared/error/components/ErrorReporter';

export {
  ExplorerStyledDataGridContainer,
} from './dataCatalogShared/style/DataGridStyles';

export {
  EmptyGridElement,
} from './dataCatalogShared/dataGrid/EmptyGridElement';

export { CountBar } from './dataCatalogShared/dataGrid/cellFormatters/CountBar';

export {
  FormattedMarkupWrapperInTooltip,
  FormattedMarkupWrapperInPage,
  FormattedMarkupWrapperProps,
  MarkupPageStyleClass,
  MarkupTooltipStyleClass,
} from './dataCatalogShared/style/MarkupStyles';

/*
 * --------------- *
 * GRAPHQL QUERIES *
 * --------------- *
 */
export {
  TagsQueryWithFilters,
  TagsQueryWithFilters_tagsConnection_nodes,
  TagsQueryWithFiltersVariables,
  TagsQueryWithFilters_tagsConnection,
} from '../gen-src/queries/TagsQueryWithFilters';
export { TagsQueryWithFiltersGql } from './queries/TagsQueryWithFiltersGql';
export {
  PublishedDSFieldCountQueryGql,
  PublishedDSFieldCountQueryGqlStr,
  PublishedDSDescriptionInheritanceForWebAuthQueryGql,
  PublishedDSDescriptionInheritanceForWebAuthQueryGqlStr,
  PublishedWBFieldCountQueryGql,
  PublishedWBFieldCountQueryGqlStr,
  PublishedWBDescriptionInheritanceForWebAuthQueryGql,
  PublishedWBDescriptionInheritanceForWebAuthQueryGqlStr,
} from './queries/DescriptionsInheritanceQueryGql';

import pg = require('../package.json');
// tslint:disable-next-line:no-console
console.info(`Data Catalog Shared v${pg.version}`);
